import { SelectHTMLAttributes, forwardRef } from 'react';

/**
 * Select — single-select dropdown atom. Consumes `enumOptions: [{value, label}]`
 * from the schema endpoint (Phase 11 Block 2 PR 1) or any other [{value,label}] array.
 *
 * Phase 11 Block 6 PR 2.
 */

export interface SelectOption {
  value: string | number;
  label: string;
}

export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  options: SelectOption[];
  placeholder?: string;
  invalid?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { options, placeholder, invalid, size = 'md', style, ...rest },
  ref,
) {
  const padY = size === 'sm' ? '6px' : size === 'lg' ? '10px' : '8px';
  const padX = size === 'sm' ? '10px' : '12px';
  const fs = size === 'sm' ? 'var(--fs-sm)' : size === 'lg' ? 'var(--fs-lg)' : 'var(--fs-md)';
  return (
    <select
      ref={ref}
      aria-invalid={invalid || undefined}
      style={{
        fontFamily: 'inherit',
        fontSize: fs,
        padding: `${padY} ${padX}`,
        border: `1px solid ${invalid ? 'var(--color-status-red)' : 'var(--color-border)'}`,
        borderRadius: 'var(--r-md)',
        background: 'var(--color-card)',
        color: 'var(--color-ink)',
        outline: 'none',
        cursor: 'pointer',
        width: '100%',
        ...style,
      }}
      {...rest}
    >
      {placeholder && <option value="">{placeholder}</option>}
      {options.map(opt => (
        <option key={String(opt.value)} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  );
});
